import { render, staticRenderFns } from "./BulmaPagination.vue?vue&type=template&id=16066a42"
import script from "./BulmaPagination.vue?vue&type=script&lang=js"
export * from "./BulmaPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16066a42')) {
      api.createRecord('16066a42', component.options)
    } else {
      api.reload('16066a42', component.options)
    }
    module.hot.accept("./BulmaPagination.vue?vue&type=template&id=16066a42", function () {
      api.rerender('16066a42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BulmaPagination/BulmaPagination.vue"
export default component.exports